"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTracking = void 0;
var Sentry = __importStar(require("@sentry/react"));
var env_handler_1 = __importDefault(require("@lima/env-handler"));
__exportStar(require("@sentry/react"), exports);
// 默认情况下仅生产环境启用sentry
var inspectSentry = location.search.includes('!inspect_sentry') || localStorage.getItem('!inspect_sentry') === 'true';
function ErrorTracking(productName, tracing, extraParams, noiseCanceling) {
    if (tracing === void 0) { tracing = {
        enabled: false
    }; }
    var integrations = [new Sentry.Replay()];
    if (tracing.enabled) {
        integrations.push(new Sentry.BrowserTracing({
            idleTimeout: 10000,
        }));
    }
    try {
        Sentry.init(__assign({ enabled: env_handler_1.default.isProd() || inspectSentry, dsn: process.env.SENTRY_DSN, release: "".concat(productName ? "".concat(productName, "@") : '').concat(process.env.SENTRY_RELEASE || 'unknown'), environment: env_handler_1.default.getEnv().split('-')[0], initialScope: {
                tags: {
                    inspect: inspectSentry
                }
            }, integrations: integrations, 
            /**
             * 忽略ResizeObserver
             * https://github.com/ant-design/ant-design/issues/15075
             */
            ignoreErrors: [/ResizeObserver/i], debug: inspectSentry, sampleRate: inspectSentry ? 1.0 : 0.1, 
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: inspectSentry ? 1.0 : 0.1, 
            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            replaysSessionSampleRate: inspectSentry ? 1.0 : 0.01, replaysOnErrorSampleRate: inspectSentry ? 1.0 : 0.5, beforeSend: function (event, hint) {
                var _a;
                // @ts-ignore
                var message = typeof (hint === null || hint === void 0 ? void 0 : hint.originalException) === 'string' ? hint === null || hint === void 0 ? void 0 : hint.originalException : (_a = hint === null || hint === void 0 ? void 0 : hint.originalException) === null || _a === void 0 ? void 0 : _a.message;
                if (message && /ResizeObserver/i.test(message)) {
                    return null;
                }
                if (noiseCanceling === null || noiseCanceling === void 0 ? void 0 : noiseCanceling(message)) {
                    return null;
                }
                return event;
            } }, extraParams));
    }
    catch (e) {
        console.error(e);
    }
}
exports.ErrorTracking = ErrorTracking;
